import { Box, Button, Flex, Text } from '@chakra-ui/react'
import { useAuth, useThreadsList } from '@hb/react'
import { useState } from 'react'
import { Link } from 'react-router'

export const PublicFooter = () => {
  const [currYear] = useState(new Date().getFullYear())
  const authUser = useAuth(s => s.authUser)
  const { threadsView } = useThreadsList()
  return (
    <Box mt="auto" w="100%">
      <Flex
        w="100%"
        px={3}
        bg="whiteAlpha.400"
        _dark={{ bg: 'blackAlpha.400' }}
        justify="space-between"
        py={1.5}
        align="center">
        <Text>©{currYear} Hamilton Billing</Text>
        <Flex mr={threadsView === 'patient' && authUser ? 12 : 0}>
          <Link to="/privacy">
            <Button size="sm" variant="link" color="blackAlpha.700" _dark={{ color: 'gray.200' }}>
              Privacy Policy
            </Button>
          </Link>
        </Flex>
      </Flex>
    </Box>
  )
}
